import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { MRT_ColumnDef } from "material-react-table";
import FormBuilder from "../../../../../../../shared/components/form-builder/form-builder";
import {
  ITCProduct,
  Option,
  transformShipmentDetails,
} from "../../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import { dtrackItService } from "../../../../tc-service/dtrackit.service";
import { TCAppConfig } from "../../../../../../../shared/app-configs/tc-app-configs";
import { mapToIShipmentConsigneeDetails } from "../../../../tc-models/tc-req-dto/tc-shipments.req_dto";
import { useApi } from "../../../../../../../shared/hooks/useApi";
import { useParams } from "react-router-dom";
import { useFormActions } from "../../../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../../../shared/hooks/useNotification";
import { Utills } from "../../../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../../../store/transaction-certificates.store";
import { Box, Typography } from "@mui/material";
interface ProductInfoProps {
  productData: ITCProduct;
  setProductData: React.Dispatch<React.SetStateAction<ITCProduct>>;
  shipmentId: string;
  formRef: any;
}
const ProductInfo: React.FC<ProductInfoProps> = ({
  formRef,
  productData,
  setProductData,
  shipmentId,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [suppInfoRequired, setSuppInfoRequired] = useState<boolean>(false);
  const [labelGrades, setLabelGrades] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [shipmentOptions, setShipmentOptions] = useState<Option[]>([]);
  const { executeGet } = useApi();
  const { TE_ID, formtype } = useParams();
  const [productDetails, setProductDetails] = useState([]);
  const [productMetrics, setProductMetrics] = useState([]);
  const {
    setProductCategoriesStore,
    setProductDetailCodeStore,
    getTCStandardGOTS,
  } = useTransactionCertificateStore();
  const hasSubmitTc: boolean = formtype === "submited-tc";

  const { setDeleteSave } = useFormActions("certified-products");
  // const [productData, setProductData] = useState<ITCProduct>(productData);
  const loadFormData = async () => {
    try {
      const response = await executeGet(TCAppConfig.GET_SHIPMENTS_ENDPOINT_V4, {
        tcId: TE_ID,
      });
      const result = response?.data.response?.flatMap((shipment: any) =>
        shipment.tcShipmentInformation?.map((detail: any) => ({
          value: detail.tcShipmentDocNo ?? "",
          label: detail.tcShipmentDocNo ?? "",
        })) || []
      ) || [];
      setShipmentOptions(result);
      if (result?.length === 1) {
        if (getTCStandardGOTS) {
          productData.tcProductShipmentNo = result?.map((r: any) => r.value);
        }
      }
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  useEffect(() => {
    const getLabelGrades = async () => {
      try {
        const result: any = await dtrackItService.getStandradLabelGrade();
        // Utills.cl(`result ${JSON.stringify(result)}`)
        const lblGrades = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
          description: t.description_1,
        }));
        Utills.cl(`lblGrades ${JSON.stringify(lblGrades)}`);
        setLabelGrades(lblGrades);
        Utills.cl(`lblGrades ${lblGrades}`);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getProductCategory = async () => {
      try {
        const result: any = TE_ID
          ? await dtrackItService.getProductCategoryByTcId(TE_ID)
          : await dtrackItService.getProductCategory();

        // Utills.cl(`result ${JSON.stringify(result)}`)

        const prdtCategory = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
          description: t.description_1,
        }));
        Utills.cl(`prdtCategory ${JSON.stringify(prdtCategory)}`);
        setProductCategory(prdtCategory);
        setProductCategoriesStore(prdtCategory);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getProductDetails = async () => {
      try {
        const result: any = TE_ID
          ? await dtrackItService.getProductDetailsCodeByTcId(TE_ID)
          : await dtrackItService.getProductDetailsCode();

        Utills.cl(`result getProductDetails ${JSON.stringify(result)}`);

        const prdtDetails = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
          description: t.description_1,
        }));
        Utills.cl(`prdtDetails ${JSON.stringify(prdtDetails)}`);
        setProductDetails(prdtDetails);
        setProductDetailCodeStore(prdtDetails);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    const getMetricsValues = async () => {
      try {
        const result: any = await dtrackItService.getMetricsValues();

        Utills.cl(`result getMetrics ${JSON.stringify(result)}`);

        const prdtDetails = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
          description: t.description_1,
        }));
        setProductMetrics(prdtDetails);
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    TE_ID && loadFormData();

    getLabelGrades();
    getProductCategory();
    getProductDetails();
    getMetricsValues();
  }, []);

  // Second useEffect to detect added/removed values

  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setProductData(productData);
  };
  const onLabelGradeChange = (e: any) => {
    Utills.cl(`onLabelGradeChange ${e}`);
  };
  const productValidationSchema = Yup.object().shape({
    // Shipment and Product Information
    // associatedShipmentNo: Yup.string().nullable(),
    tcProductDetailCode: Yup.string().required("Product Details are required"),
    tcProductCategoryCode: Yup.string().required(
      "Product Category Code is required"
    ),

    tcProductNetShippingWeight: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true; // Allow empty values
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .required("Product Net Shipping Weight is required")
      .typeError("Product Net Shipping Weight must be a valid number"),

    tcProductSupplementaryWeight: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true;
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .test(
        "supplementary-less-than-net",
        "Supplementary Weight must be less than Net Shipping Weight",
        function (value: any) {
          const netWeight = parseFloat(this.parent.tcProductNetShippingWeight);
          const suppWeight = parseFloat(value);
          if (isNaN(netWeight) || isNaN(suppWeight)) return true;
          return (netWeight === 0 && suppWeight === 0) || suppWeight < netWeight;
        }
      )
      .nullable(),
    tcProductInfoSupplementaryWeight: Yup.string().when("tcProductSupplementaryWeight", {
      is: (val: any) => {
        if (val === undefined || val === null) return false;
        const str = String(val).trim();
        if (!str) return false;
        // treat '0' or 0 as empty (only require info when meaningful value provided)
        const num = Number(str);
        if (!isNaN(num) && num === 0) return false;
        return true;
      },
      then: Yup.string().required(
        "Supplementary Weight Info is required when Supplementary Weight is provided"
      ),
      otherwise: Yup.string().nullable(),
    }),
    tcProductOrderNo: Yup.array()
      .of(
        Yup.string()
          .required("Order Number is required")
          .matches(
            /^[^\s]+$/,
            "Order Number cannot have white spaces"
          )
      )
      .min(1, "At least one Order Number is required")
      .required("Order Number is required")
      .max(255, "Maximum 255 Characters are allowed"),

    tcProductArticleNo: Yup.string()
      .required("Article Number is required")
      .matches(/^.+$/, "Article Number cannot be empty")
      .max(2000, "Maximum 2000 Characters are allowed"),


    tcProductNumberOfUnits: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true;
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value);
        }
      )
      .required("TC Product Number of Units is required")
      .typeError("TC Product Number of Units must be a valid number"),

    tcProductUnitsMetric: Yup.string()
      .required("Units Metric is required")
      .max(40, "Maximum 40 Characters are allowed"),

    tcProductInfoAssociatedTc: Yup.string().nullable(),
    tcProductCategoryUserSpecificTerm: Yup.string()
      .nullable()
      .max(255, "Maximum 255 Characters is allowed"),
    tcProductDetailUserSpecificTerm: Yup.string()
      .nullable()
      .max(255, "Maximum 255 Characters is allowed"),
    tcProductProductionDate: Yup.string().nullable(),
    tcProductCategoryDescription: Yup.string().nullable(),
    tcProductDetailDescription: Yup.string().nullable(),

    tcProductShipmentNo: Yup.array()
      .of(Yup.string())
      .min(1, "Shipment Number is required")
      .required("Shipment Number is required"),
  });

  const formConfig = {
    pageName: "certified-products",
    subPageName: "tcProductInformation",
    initialValues: productData,
    enableReinitialize: true,
    validationSchema: productValidationSchema,
    sections: [
      {
        title: "Add Product",
        fields: [
          // Row 1: Column 1 - Article No, Column 2 - Order No, Column 3 - Production Date
          {
            label: "Product Article Number",
            name: "tcProductArticleNo",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            readOnly: hasSubmitTc,
            value: productData.tcProductArticleNo,
            props: {
              placeholder: "Enter product article no.",
            },
          },
          {
            label: "Product Production Date",
            name: "tcProductProductionDate",
            type: "date",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductProductionDate,
            props: {
              placeholder: "YYYY-MM-DD",
            },
          },
          {
            label: "Product Order Number",
            name: "tcProductOrderNo",
            type: "chips",
            gridSize: { xs: 12, md: 12, lg: 12 },
            required: true,
            value: productData.tcProductOrderNo,
            props: {
              placeholder: "Enter product order no. (Press Enter on keyboard after each value)",
            },
          },

          // Row 2: Column 1 - Shipment No, Column 2 - Number of Units, Column 3 - Units Metric
          {
            label: "Product Shipment",
            name: "tcProductShipmentNo",
            readOnly: hasSubmitTc,
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            props: {
              options: shipmentOptions,
              placeholder: "Select product shipment no.",
              multiple: true,
            },
          },
          {
            label: "Product Number of Units",
            name: "tcProductNumberOfUnits",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductNumberOfUnits,
            props: {
              placeholder: "Enter product number of units",
              type: "number",
            },
          },
          {
            label: "Product Units Metric",
            name: "tcProductUnitsMetric",
            type: "select",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductUnitsMetric,
            props: {
              options: productMetrics,
              placeholder: "Select product unit metric",
            },
          },
          // Row 3: Column 1 - Net Weight, Column 2 - Supplementary Weight, Column 3 - Supplementary Weight Info
          {
            label: "Product Net Shipping Weight",
            name: "tcProductNetShippingWeight",
            type: "number",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: true,
            value: productData.tcProductNetShippingWeight,
            props: {
              type: "number",
              placeholder: "Enter product net shipping weight",
            },
          },
          {
            label: "Product Supplementary Weight",
            name: "tcProductSupplementaryWeight",
            type: "number",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: false,
            value: productData.tcProductSupplementaryWeight,
            props: {
              type: "number",
              placeholder: "Enter product supplementary weight",
            },
            events: {
              onChange: (newValue: any, updatedValues: any, setFieldValue: (field: string, value: any) => void) => {
                try {
                  const val = updatedValues?.tcProductSupplementaryWeight;
                  const hasVal = val !== undefined && val !== null && String(val).trim() !== "" && !(Number(String(val).trim()) === 0);
                  setSuppInfoRequired(Boolean(hasVal));
                } catch (e) {
                  setSuppInfoRequired(false);
                }
              }
            },
          },
          {
            label: "Product Supplementary Weight Info",
            name: "tcProductInfoSupplementaryWeight",
            type: "text",
            gridSize: { xs: 12, md: 4, lg: 4 },
            required: suppInfoRequired,
            value: productData.tcProductInfoSupplementaryWeight,
            props: {
              placeholder: "Enter product supplementary weight info",
            },
          },
          // Row 4: Column 1 - Category Code, Column 2 - Category User Specific Term
          {
            label: "Product Category Code",
            name: "tcProductCategoryCode",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: true,
            value: productData.tcProductCategoryCode,
            events: {
              onChange: (newValue: string, updatedValues: any, setFieldValue: (field: string, value: any) => void) => {
                const selectedOption: any = productDetails.find((opt: any) => opt.value === newValue);
                if (selectedOption) {
                  setFieldValue("tcProductDetailDescription", selectedOption?.description);
                } else {
                  setFieldValue("tcProductDetailDescription", "");
                }
              },
            },
            props: {
              enableSearch: true,
              options: productCategory,
              placeholder: "Select product Category code",
            },
          },
          {
            label: "Product Category Code User Specific Term",
            name: "tcProductCategoryUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            value: productData.tcProductCategoryUserSpecificTerm,
            props: {
              placeholder: "Enter product category code user specific term",
            },
          },
          // Row 5: Column 1 - Detail Code, Column 2 - Detail User Specific Term
          {
            label: "Product Detail Code",
            name: "tcProductDetailCode",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: true,
            value: productData.tcProductDetailCode,
            events: {
              onChange: (newValue: string, updatedValues: any, setFieldValue: (field: string, value: any) => void) => {
                const selectedOption: any = productDetails.find((opt: any) => opt.value === newValue);
                if (selectedOption) {
                  setFieldValue("tcProductDetailDescription", selectedOption.description);
                } else {
                  setFieldValue("tcProductDetailDescription", "");
                }
              },
            },
            props: {
              enableSearch: true,
              options: productDetails,
              placeholder: "Select product Detail code",
            },
          },
          {
            label: "Product Detail Code User Specific Term",
            name: "tcProductDetailUserSpecificTerm",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: false,
            value: productData.tcProductDetailUserSpecificTerm,
            props: {
              placeholder: "Enter product detail code user specific term",
            },
          },
          // {
          //   label: "Product Info Associated Tc", //label: 'Associated Product Info', renamed to match table header
          //   name: "tcProductInfoAssociatedTc",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //   required: false,
          //   value: productData.tcProductInfoAssociatedTc,
          //   props: {
          //     placeholder: "Enter Associated Product Info",
          //   },
          // },
          // {
          //   label: 'Product Certified Weight',
          //   name: 'tcProductCertifiedWeight',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //   required: !getTCStandardGOTS ? true : false,
          //   props: {
          //     type: 'number',
          //     placeholder: 'Enter TC Product Certified Weight',
          //   },
          // },
          // {
          //   label: 'Product Standard (Label Grade)',
          //   name: 'tcProductStandardLabelGrade',
          //   type: 'select',
          //   gridSize: { xs: 12, md: 4, lg: 4 },
          //   required: !getTCStandardGOTS ? true : false,
          //   events: { onChange: onLabelGradeChange },
          //   // value: productData?.tcProductStandardInformation?.tcProductStandardLabelGrade,
          //   props: {
          //     options: labelGrades,
          //     placeholder: 'Select TC Product Standard (Label Grade)',
          //   },
          // },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      Utills.cl("Form Submitted: Product Info", values);
      setProductData(values);
      toggleDrawer();
      // resetForm();
    },
  };

  return (
    <>
      {showWarning && (
        <Box
          sx={{
            p: 2,
            mb: 2,
            bgcolor: "#FFF3E0",
            borderRadius: 1,
            border: "1px solid #FFB74D",
          }}
        >
          <Typography color="warning.dark">
            Note: Any changes to the Certified Organization (CO) details should
            be made in the "Certified Organization Details" tab.
          </Typography>
        </Box>
      )}
      {/* <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
        <StyledButton variant="contained" onClick={toggleDrawer}>Add Product</StyledButton>
      </Box>
      <Box display="grid">
      <CustomTable
        columns={columns}
        data={data}
        enableTopToolbar={false}
        enableBottomToolbar={true}
        enableRowActions={true}
        renderRowActions={({ row }) => (
          <ActionsMenu
            // onEdit={() => handleEdit(row)}
            // onDelete={() => handleDelete(row)}
            row={row}
          />
        )}
      />
      </Box> */}
      {/* <ModalPopup open={drawerOpen} onClose={toggleDrawer} onSave={handleSubmit}> */}
      <FormBuilder
        formConfig={formConfig}
        onSubmit={formConfig.handleSubmit}
        formRef={formRef}
      />
      {/* </ModalPopup> */}
    </>
  );
};

export default ProductInfo;
